export const NEW_ACCOUNT_THRESHOLD_SECONDS = 60;
